<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>ENVIRONMENTAL SAFEGUARD PROYEK</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">HOME </a></li>
                                <li class="breadcrumb-item active">ENVIRONMENTAL SAFEGUARD PROYEK</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12  wow fadeInDown" v-if="(roleuser == 'admin')" style="display: none;">
                            <div class="card collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>Import Data Excel</label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="col-sm-12">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left"
                                                    title="Unduh master excel.." @click="G_tableCSV('_Monev_')">
                                                    <i class="fas fa-download"></i> Unduh Master Data Monev .xlsx
                                                </button>
                                            </a>
                                        </div>
                                        <!--IKON PETA 1-->
                                        <div class="col-sm-12">
                                            <label>Pilih File<small class="text-info"> (*.xlsx)</small>
                                            </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="far fa-file-image"></i></span>
                                                </div>
                                                <input type="file" class="form-control form-control-sm"
                                                    id="fileToUploadfilenya_excel" name="fileToUploadfilenya_excel"
                                                    placeholder="fileToUpload" style="font-size: smaller;"
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    @change="onChange">
                                                <input type="hidden" class="form-control form-control-sm"
                                                    id="filenya_excel" name="filenya_excel" placeholder="File Excel">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Opsi</label>
                                            <div class="row">
                                                <div class="col-sm-10">
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar" aria-valuenow="0"
                                                            aria-valuemin="0" aria-valuemax="100" style="width:0%"
                                                            id="persennyafilenya_excel">
                                                            <span id="tulisanpersenfilenya_excel">0%</span>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <span class="text-success" id="suksesnyafilenya_excel"></span>
                                                </div>
                                                <div class="col-sm-2 text-center" v-if="tempjumlah > 0">
                                                    <button type="button"
                                                        class="btn btn-warning btn-sm lebar text-white"
                                                        @click="uploadsavedata()">
                                                        Simpan ke DB
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <!--IKON PETA 1 END-->
                                        <div class="col-sm-12">
                                            Jumlah Data excel siap Import: {{ tempjumlah }}
                                            <span style="float: right;">Jumlah Data excel Tersimpan di DB: {{
                                                tempjumlahdb
                                                }}</span>
                                            <div class="table-responsive table-wrapper" v-if="tempjumlah > 0">
                                                <table class="table m-0" id="tabeldata2">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Urut
                                                            </th>
                                                            <template v-for="(dataheader, urutheader) in tempheader"
                                                                :key="urutheader">
                                                                <th>
                                                                    {{ dataheader }}
                                                                </th>
                                                            </template>
                                                        </tr>
                                                    </thead>
                                                    <template v-for="(datadata, urutdata) in tempdata" :key="urutdata">
                                                        <tr>
                                                            <td>{{ urutdata + 1 }}</td>
                                                            <td v-for="(isidata, urutisi) in datadata" :key="urutisi">
                                                                {{ isidata }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>Filter Kolom</label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body px-3">
                                    <div class="row">
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxStatusKegiatan"
                                                    value="optionStatusKegiatan"
                                                    @click="showColumnStatusKegiatan = !showColumnStatusKegiatan">
                                                <label for="customCheckboxStatusKegiatan" class="custom-control-label">
                                                    Status Kegiatan</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxOWP" value="optionOWP"
                                                    @click="showColumnOWP = !showColumnOWP">
                                                <label for="customCheckboxOWP" class="custom-control-label">
                                                    OWP</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxKontrak" value="optionKontrak"
                                                    @click="showColumnKontrak = !showColumnKontrak">
                                                <label for="customCheckboxKontrak" class="custom-control-label">
                                                    Nilai Kontrak</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxMulai" value="optionMulai"
                                                    @click="showColumnMulai = !showColumnMulai">
                                                <label for="customCheckboxMulai" class="custom-control-label">
                                                    Mulai</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxSelesai" value="optionSelesai"
                                                    @click="showColumnSelesai = !showColumnSelesai">
                                                <label for="customCheckboxSelesai" class="custom-control-label">
                                                    Selesai</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>
                                        Filter Data
                                    </label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body px-3">
                                    <div class="row">
                                        <div class="col-sm-6 text-center">
                                            <label>PIU</label>
                                            <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                                style="background-color: #ffffff;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center" style="display: none;">
                                            <label>
                                                Jenis Kegiatan
                                            </label>
                                            <v-select :options="jenispekerjaan2" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedjenispekerjaan2"
                                                @update:modelValue="onjenispekerjaan2Change"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center" style="display: none;">
                                            <label>
                                                Tahun
                                            </label>
                                            <v-select :options="tahunmulai2" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedtahunmulai2"
                                                @update:modelValue="ontahunmulai2Change"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center" style="display: none;">
                                            <label>
                                                Lokasi
                                            </label>
                                            <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center">
                                            <label>
                                                Komponen
                                            </label>
                                            <v-select :options="komponen" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedkomponen" @update:modelValue="onkomponenChange"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center">
                                            <label>
                                                Sub Komponen
                                            </label>
                                            <v-select :options="subkomponen" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedsubkomponen"
                                                @update:modelValue="onsubkomponenChange"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                    <div class="col-sm-12 float-left pb-2 px-3 wow fadeInDown">
                                        Jumlah Data {{ G_numFormat(jumlahdata) }}
                                        <span style="float: right;display: none;">
                                            <span>Halaman ke: </span>
                                            <select v-model="halaman" @change="onChangeHalaman($event)">
                                                <option v-for="index in jumlahhalaman" :key="index">
                                                    {{ index }}</option>
                                            </select>
                                            <span> dari </span> {{ jumlahhalaman }}
                                        </span>
                                    </div>
                                    <div class="col-sm-12 float-left pb-2">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian" @keyup="ambildatakata()">
                                    </div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata" style="font-size: x-small;">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;" rowspan="3">No</th>
                                                    <th style="width: 100px;" rowspan="3">Opsi</th>
                                                    <th style="width: 100px;" rowspan="3">PIU</th>
                                                    <th style="width: 200px;" rowspan="3">Kegiatan</th>
                                                    <th style="width: 100px;" rowspan="3"
                                                        v-if="showColumnStatusKegiatan">Status<br>Kegiatan
                                                    </th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnOWP">
                                                        OWP<br>(Rp.)</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnKontrak">Nilai
                                                        Kontrak<br>(Rp.)</th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnMulai">Mulai
                                                    </th>
                                                    <th style="width: 50px;" rowspan="3" v-if="showColumnSelesai">
                                                        Selesai</th>
                                                    <th style="width: 50px;" :colspan="colspantahapan">
                                                        Proses Environmental</th>
                                                </tr>
                                                <tr>
                                                    <template
                                                        v-for="(datatahapanproses, uruttahapanproses) in tahapanproses"
                                                        :key="uruttahapanproses">
                                                        <th :colspan="datatahapanproses.colspan" style="width: 50px;">
                                                            {{ datatahapanproses.nama }}
                                                        </th>
                                                    </template>
                                                </tr>
                                                <tr>
                                                    <template
                                                        v-for="(datatahapanproses, uruttahapanproses) in tahapanproses"
                                                        :key="uruttahapanproses">
                                                        <template
                                                            v-for="(datatahapanprosesdetail, uruttahapanprosesdetail) in datatahapanproses.detail"
                                                            :key="uruttahapanprosesdetail">
                                                            <th style="width: 50px;">
                                                                {{ datatahapanprosesdetail.nama }}
                                                            </th>
                                                        </template>
                                                    </template>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td :class="datalist.class">{{ urutlist + 1 }}</td>
                                                        <td :class="datalist.class" class="text-center">
                                                            <button type="button" style="width: 90px;"
                                                                class="btn btn-primary3 btn-sm text-white"
                                                                @click="prosesdata(datalist.id, datalist.MULAI, datalist.SELESAI)"
                                                                data-toggle="tooltip" data-placement="left"
                                                                title="Environmental Data.."><i class="fas fa-edit"></i>
                                                                Data
                                                            </button>
                                                        </td>
                                                        <td :class="datalist.class">
                                                            {{ datalist.nama_satker }}
                                                        </td>
                                                        <td :class="datalist.class">
                                                            <span v-html="datalist.Nama_Kegiatan"></span>
                                                        </td>
                                                        <td :class="datalist.class" v-if="showColumnStatusKegiatan">
                                                            {{ datalist.Status_pekerjaan }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-right"
                                                            v-if="showColumnOWP">
                                                            {{ G_numFormat(datalist.OWP) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-right"
                                                            v-if="showColumnKontrak">
                                                            {{ G_numFormat(datalist.NILAIKONTRAK) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnMulai">
                                                            {{ G_formatDateNonWIB(datalist.MULAI) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnSelesai">
                                                            {{ G_formatDateNonWIB(datalist.SELESAI) }}
                                                        </td>
                                                        <template
                                                            v-for="(datalistenvironmental, urutlistenvironmental) in datalist.environmental"
                                                            :key="urutlistenvironmental">
                                                            <template
                                                                v-for="(detailenvironmental, urutdetailenvironmental) in datalistenvironmental.detail"
                                                                :key="urutdetailenvironmental">
                                                                <td class="text-center"
                                                                    :style="'background-color:' + detailenvironmental.class">
                                                                    {{ detailenvironmental.progres }}
                                                                </td>
                                                            </template>
                                                        </template>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    <label>Data masih kosong</label>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import readXlsxFile from 'read-excel-file';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            datapesan: '',
            datamaster: [],
            carikata: '',
            colspan: 0,
            datatahun: [],
            showColumnStatusKegiatan: false,
            showColumnOuput: false,
            showColumnSubKomponen: false,
            showColumnPHOFHO: false,
            showColumnPenyedia: false,
            showColumnMulai: false,
            showColumnSelesai: false,
            showColumnDurasi: false,
            showColumnKontrak: false,
            showColumnAdendum: false,
            showColumnBerjalan: false,
            showColumnTersisa: false,
            showColumnOWP: false,
            showColumnTotalAWP: false,
            showColumnAWP: false,
            showColumnTotalDIPA: false,
            showColumnDIPA: false,
            showColumnCapaian: false,
            showColumnKeterangan: false,
            showColumnLatitude: false,
            showColumnLongitude: false,
            project_id: process.env.VUE_APP_PROJECT_ID,
            tempexcel: [],
            ekportexcel: [],
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
            jenispekerjaan2: [],
            datajenispekerjaan2: [],
            defaultSelectedjenispekerjaan2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedjenispekerjaan2: '',

            tahunmulai2: [],
            datatahunmulai2: [],
            defaultSelectedtahunmulai2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunmulai2: '',
            komponen: [],
            datakomponen: [],
            defaultSelectedkomponen: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedkomponen: '',

            subkomponen: [],
            datasubkomponen: [],
            defaultSelectedsubkomponen: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedsubkomponen: '',
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedlokasi: '',
            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedid_user: 0,
            halamanawal: 0,
            piuawal: 0,
            kegiatanawal: 0,
            tahunawal: 0,
            lokasiawal: 0,
            komponenawal: 0,
            subkomponenawal: 0,
            carikataawal: '',
            tahapanproses: [],
            colspantahapan: 0,
        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        prosesdata(kode, mulai, selesai) {
            if (mulai == '0000-00-00' || selesai == '0000-00-00') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Tanggal Kontrak Belum Ada / Lengkap..',
                });
                return false;
            }
            else {
                var tambahan = "_" + this.halaman + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikata;
                //alert(this.halaman);
                var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode + tambahan, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                window.location.replace("/ProsesEnvironment/" + bytes);
            }
        },
        ambildatakata() {
            this.carikataawal = this.carikata;
            this.ambildata();
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationreffmonitoring-JenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.defaultSelectedjenispekerjaan2 = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.datajenispekerjaan2 = [];
                        this.jenispekerjaan2 = [];
                        this.datajenispekerjaan2 = Response.data.content.data;
                        this.datajenispekerjaan2.forEach((item) => {
                            if (this.kegiatanawal == item.id) {
                                this.selectedjenispekerjaan2 = this.kegiatanawal;
                                this.defaultSelectedjenispekerjaan2 = {
                                    label: item.nama,
                                    code: this.datajenispekerjaan2.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                            this.jenispekerjaan2.push({
                                label: item.nama,
                                code: this.datajenispekerjaan2.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });

                        this.jenispekerjaan2.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationreffmonitoring-TahunProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datatahunmulai2 = [];
                        this.tahunmulai2 = [];
                        this.defaultSelectedtahunmulai2 = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.datatahunmulai2 = Response.data.content.data;
                        this.datatahunmulai2.forEach((item) => {
                            if (this.tahunawal == item.tahun) {
                                this.selectedtahunmulai2 = this.tahunawal;
                                this.defaultSelectedtahunmulai2 = {
                                    label: item.tahun,
                                    code: this.datatahunmulai2.indexOf(item) + 1,
                                    tag: item.tahun,
                                };
                            }

                            this.tahunmulai2.push({
                                label: item.tahun,
                                code: this.datatahunmulai2.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });
                        this.tahunmulai2.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationKomponen-GetProyekKomponen?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datakomponen = [];
                        this.komponen = [];
                        this.defaultSelectedkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };

                        this.datakomponen = Response.data.content.data;

                        this.datakomponen.forEach((item) => {
                            if (this.komponenawal == item.id) {
                                this.selectedkomponen = this.komponenawal;
                                this.defaultSelectedkomponen = {
                                    label: item.nama,
                                    code: this.datakomponen.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                            this.komponen.push({
                                label: item.nama,
                                code: this.datakomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.komponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedkomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.defaultSelectedsubkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };

                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.datasubkomponen = Response.data.content.data;
                        this.datasubkomponen.forEach((item) => {
                            if (this.subkomponenawal == item.id) {
                                this.selectedsubkomponen = this.subkomponenawal;
                                this.defaultSelectedsubkomponen = {
                                    label: item.nama,
                                    code: this.datasubkomponen.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                            this.subkomponen.push({
                                label: item.nama,
                                code: this.datasubkomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.subkomponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });

                    }
                    else {
                        this.defaultSelectedsubkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.subkomponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI5.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.defaultSelectedlokasi = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };

                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            if (this.lokasiawal == item.id) {
                                this.selectedlokasi = this.lokasiawal;
                                this.defaultSelectedlokasi = {
                                    label: item.nama,
                                    code: this.datalokasi.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            this.halamanloading = true;
            const mainAPI6 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });

            var random = Math.random();
            await mainAPI6.get("parastapainnovation_userproject-GetPIU?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            if (this.piuawal == item.user_id) {
                                this.selectedid_user = this.piuawal;
                                this.defaultSelectedid_user = {
                                    label: item.nama_satker,
                                    code: this.dataid_user.indexOf(item) + 1,
                                    tag: item.user_id,
                                };
                            }
                            this.id_user.push({
                                label: item.nama_satker,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            var random = Math.random();
            await mainAPI6.get("parastapainnovationenv-TahapanEnv?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.tahapanproses = [];
                        this.tahapanproses = Response.data.content.data;
                        this.colspantahapan = Response.data.content.colspan;
                        this.halamanloading = false;

                    }
                    else {
                        this.colspantahapan = 0;
                        this.tahapanproses = [];
                    }
                }
            ).catch(error => {
                this.colspantahapan = 0;
                this.tahapanproses = [];
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
                this.piuawal = this.id_user[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
                this.lokasiawal = this.lokasi[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi);
            this.ambildata();
        },
        onjenispekerjaan2Change(a) {
            try {
                this.selectedjenispekerjaan2 = this.jenispekerjaan2[a].tag;
                this.kegiatanawal = this.jenispekerjaan2[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedjenispekerjaan2)
            this.ambildata();

            //alert(this.selectedjenispekerjaan2);
        },
        ontahunmulai2Change(a) {
            try {
                this.selectedtahunmulai2 = this.tahunmulai2[a].tag;
                this.tahunawal = this.tahunmulai2[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onkomponenChange(a) {
            try {
                this.selectedkomponen = this.komponen[a].tag;
                this.komponenawal = this.komponen[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedkomponen)
            this.getsubkomponen();

            //alert(this.selectedkomponen);
        },
        onsubkomponenChange(a) {
            try {
                this.selectedsubkomponen = this.subkomponen[a].tag;
                this.subkomponenawal = this.subkomponen[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            this.ambildata();
            //alert(this.selectedsubkomponen)
            //this.rubahdatagrafik();

            //alert(this.selectedsubkomponen);
        },
        async getsubkomponen() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedkomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.datasubkomponen = Response.data.content.data;
                        this.datasubkomponen.forEach((item) => {
                            this.subkomponen.push({
                                label: item.nama,
                                code: this.datasubkomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedsubkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.subkomponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.defaultSelectedsubkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.subkomponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            this.halamanawal = 1;
            this.ambildata();
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("parastapainnovationhapusmonev-HapusDataManualMonev", data).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.replace("/Monev");
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        proseskendala(kode) {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/KendalaTindakLanjut/" + bytes);
        },
        prosesdatatarget(kode, mulai, selesai) {
            if (mulai == '0000-00-00' || selesai == '0000-00-00' || mulai == '' || selesai == '' || mulai == null || selesai == null) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Tanggal Mulai Dan Selesai Kontrak Terlebih Dahulu..',
                });
                return false;
            }
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/ProsesKurvaS/" + bytes);
        },
        prosesdatapdo(kode, komponen, subkomponen, akhir) {
            //alert(komponen);
            //alert(subkomponen);
            //return false;
            if ((komponen == '') || (komponen == null) || (subkomponen == '') || (subkomponen == null) || (akhir == '') || (akhir == null)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Komponen /  Sub Komponen Dan Akhir Kontrak Data..',
                });
                return false;
            }
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/ProsesPDOMonev/" + bytes);
        },
        async G_tableCSV(namefile) {
            this.ekportexcel = [];
            this.halamanloading = true;
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonev-AllMonev?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.colspan = 0;
                    this.datatahun = [];
                    this.colspan = Response.data.jumlahtahun;
                    this.datatahun = Response.data.tahun;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.tempexcel = [];
                        this.tempexcel = Response.data.content.data;
                        for (let i = 0; i < this.tempexcel.length; i++) {
                            this.ekportexcel.push({
                                "No": i + 1,
                                "PIU": this.tempexcel[i].nama_satker,
                                "Nama Kegiatan": this.tempexcel[i].Nama_Kegiatan,
                                "Lokasi": this.tempexcel[i].Lokasi,
                                "Komponen": this.tempexcel[i].Komponen,
                                "Kategori": this.tempexcel[i].Kategori,
                                "Status Pekerjaan": this.tempexcel[i].Status_pekerjaan,
                                "BankReview": this.tempexcel[i].BankReview,
                                "PHO FHO": this.tempexcel[i].PHO_FHO,
                                "Tanggal PHO FHO": this.tempexcel[i].tanggalPHO_FHO,
                                "TARGET": this.tempexcel[i].TARGET,
                                "PROGRES": this.tempexcel[i].PROGRES,
                                "REALISASI KUMULATIF": this.tempexcel[i].REALISASI_KUMULATIF,
                                "PROGRES KEUANGAN": this.tempexcel[i].PROGRESKEUANGAN,
                                "KONTRAKTOR / PENYEDIA": this.tempexcel[i].KONTRAKTOR,
                                "MULAI": this.tempexcel[i].MULAI,
                                "SELESAI": this.tempexcel[i].SELESAI,
                                "NILAI KONTRAK": this.tempexcel[i].NILAIKONTRAK,
                                "NO KONTRAK": this.tempexcel[i].NOKONTRAK,
                                "ADENDUM": this.tempexcel[i].ADENDUM,
                                "OWP": this.tempexcel[i].OWP,
                                "AWP2023": this.tempexcel[i].AWP[0].Nilai,
                                "AWP2024": this.tempexcel[i].AWP[1].Nilai,
                                "AWP2025": this.tempexcel[i].AWP[2].Nilai,
                                "AWP2026": this.tempexcel[i].AWP[3].Nilai,
                                "AWP2027": this.tempexcel[i].AWP[4].Nilai,
                                "AWP2028": this.tempexcel[i].AWP[5].Nilai,
                                "DIPA2023": this.tempexcel[i].DIPA[0].Nilai,
                                "DIPA2024": this.tempexcel[i].DIPA[1].Nilai,
                                "DIPA2025": this.tempexcel[i].DIPA[2].Nilai,
                                "DIPA2026": this.tempexcel[i].DIPA[3].Nilai,
                                "DIPA2027": this.tempexcel[i].DIPA[4].Nilai,
                                "DIPA2028": this.tempexcel[i].DIPA[5].Nilai,
                                "ADENDUM": this.tempexcel[i].ADENDUM,
                                "TARGET CAPAIAN": this.tempexcel[i].TARGETCAPAIAN,
                                "REALISASI CAPAIAN": this.tempexcel[i].REALISASICAPAIAN,
                                "LATITUDE": this.tempexcel[i].LATITUDE,
                                "LONGITUDE": this.tempexcel[i].LONGITUDE,
                                "TANGGAL DATA": this.tempexcel[i].TANGGALDATA,
                            });
                        }
                        function formatColumn(worksheet, col, fmt) {
                            const range = XLSX.utils.decode_range(worksheet['!ref'])
                            // note: range.s.r + 1 skips the header row
                            for (let row = range.s.r + 1; row <= range.e.r; ++row) {
                                const ref = XLSX.utils.encode_cell({ r: row, c: col })
                                if (worksheet[ref] && worksheet[ref].t === 'n') {
                                    worksheet[ref].z = fmt
                                }
                            }
                        }
                        const currency = '0.00';
                        const XLSX = xlsx;
                        const workbook = XLSX.utils.book_new();
                        const worksheet = XLSX.utils.json_to_sheet(this.ekportexcel);

                        // ARRAY NUMBER SILAHKAN MASUKKAN NOMOR KOLOM
                        for (let col of [10, 11, 12, 13, 17, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 36, 37, 38, 39]) {
                            formatColumn(worksheet, col, currency)
                        }
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Monev");
                        XLSX.writeFile(workbook, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
                        this.halamanloading = false;
                    }
                    else {
                        this.tempexcel = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
            //console.log(this.datamaster);
            //return false;
        },
        onChange_old(event) {
            this.tempjumlahdb = 0;
            try {
                if (event.target.files[0]['type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    this.file = event.target.files ? event.target.files[0] : null;
                    if (this.file) {
                        this.tempheader = [];
                        this.tempdata = [];
                        readXlsxFile(this.file).then((rows) => {
                            // `rows` is an array of rows
                            // each row being an array of cells.
                            //alert(rows.length);
                            this.halamanloading = true;
                            this.tempjumlah = rows.length - 1;
                            //alert(this.tempjumlah);
                            for (let i = 0; i < rows.length; i++) {
                                this.halamanloading = true;
                                if (i == 0) {
                                    var varheader = rows[i];
                                    for (let x = 0; x < varheader.length; x++) {
                                        this.tempheader.push(varheader[x]);
                                    }
                                }
                                else {
                                    this.tempdata.push(rows[i]);
                                }
                                document.getElementById('persennyafilenya_excel').style.width = Math.round((i / (rows.length - 1)) * 100) + "%";
                                document.getElementById('tulisanpersenfilenya_excel').innerHTML = Math.round((i / (rows.length - 1)) * 100) + "%";
                            }
                            //alert(JSON.stringify(this.tempheader));
                            //console.log(this.tempdata);
                            this.halamanloading = false;
                        })
                    }
                }
                else {
                    swal.fire('Peringatan', 'File tidak sesuai format', 'error');
                    return false;
                }
            } catch (error) {

            }

        },
        async uploadsavedata() {
            //alert(JSON.stringify(this.tempheader));
            //alert(JSON.stringify(this.tempdata));
            var tempheader = this.tempheader;
            //console.log(JSON.stringify(this.tempdata));
            //alert(this.tempdata.length);
            //return false;
            var temparraydata = ''
            for (let i = 0; i < this.tempdata.length; i++) {
                var data = "";
                for (let x = 0; x < this.tempdata[i].length; x++) {
                    if (x == 0) {
                        data = this.tempdata[i][x];
                    }
                    else {
                        data = data + '|' + this.tempdata[i][x];
                    }
                }
                if (i == 0) {
                    temparraydata = temparraydata + data;
                }
                else {
                    temparraydata = temparraydata + '|+|' + data;
                }
            }
            //console.log(JSON.stringify(tempheader));
            //console.log(temparraydata);
            //return false;

            var fd = new FormData();
            fd.append("tempheader", tempheader);
            fd.append("data", temparraydata);
            fd.append("project_id", this.project_id);
            fd.append("kolom", 'STATUSPROYEK');
            fd.append("tabel", 'zpartial_pmc_master_f_dan_k');
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            this.halamanloading = true;
            await mainAPI.post("parastapainnovation_excelQSmonev-SaveQSExcel", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        this.halamanloading = false;
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        this.halamanloading = false;
                        swal.fire('Informasi', 'Data telah diimport..', 'success').then(function () {
                            window.location.replace("/Monev");
                        });

                    }
                }
            ).catch(function (error) {
                //this.halamanloading = false;
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

        },
        onChange(event) {
            this.tempjumlahdb = 0;
            try {
                if (event.target.files[0]['type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    this.file = event.target.files ? event.target.files[0] : null;
                    if (this.file) {
                        this.tempheader = [];
                        this.tempdata = [];
                        readXlsxFile(this.file).then((rows) => {
                            // `rows` is an array of rows
                            // each row being an array of cells.
                            //alert(rows.length);
                            this.halamanloading = true;
                            this.tempjumlah = rows.length - 1;
                            //alert(this.tempjumlah);
                            for (let i = 0; i < rows.length; i++) {
                                this.halamanloading = true;
                                if (i == 0) {
                                    var varheader = rows[i];
                                    for (let x = 0; x < varheader.length; x++) {
                                        this.tempheader.push(varheader[x]);
                                    }
                                }
                                else {
                                    this.tempdata.push(rows[i]);
                                }
                                document.getElementById('persennyafilenya_excel').style.width = Math.round((i / (rows.length - 1)) * 100) + "%";
                                document.getElementById('tulisanpersenfilenya_excel').innerHTML = Math.round((i / (rows.length - 1)) * 100) + "%";
                            }
                            //alert(JSON.stringify(this.tempheader));
                            //console.log(this.tempdata);
                            this.halamanloading = false;
                        })
                    }
                }
                else {
                    swal.fire('Peringatan', 'File tidak sesuai format', 'error');
                    return false;
                }
            } catch (error) {

            }
        },
        async uploadsavedata_old() {
            this.tempjumlahdb = 0;
            var tempheader = this.tempheader;
            //console.log(JSON.stringify(this.tempdata));
            //alert(this.tempdata.length);
            //return false;
            var temparraydata = ''
            for (let i = 0; i < this.tempdata.length; i++) {
                var data = "";
                for (let x = 0; x < this.tempdata[i].length; x++) {
                    if (x == 0) {
                        data = this.tempdata[i][x];
                    }
                    else {
                        data = data + '|' + this.tempdata[i][x];
                    }
                }
                if (i == 0) {
                    temparraydata = temparraydata + data;
                }
                else {
                    temparraydata = temparraydata + '|+|' + data;
                }
            }
            //console.log(temparraydata);
            //return false;
            var fd = new FormData();
            fd.append("tempheader", tempheader);
            fd.append("data", temparraydata);
            fd.append("project_id", this.project_id);
            fd.append("kolom", 'STATUSPROYEK');
            fd.append("tabel", 'zpartial_pmc_master_f_dan_k');
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            this.halamanloading = true;
            await mainAPI.post("parastapainnovation_excelmonev-SaveExcel", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        this.halamanloading = false;
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        this.halamanloading = false;
                        swal.fire('Informasi', 'Data telah diimport..', 'success').then(function () {
                            window.location.replace("/Monev");
                        });

                    }
                }
            ).catch(function (error) {
                //this.halamanloading = false;
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            //alert(tempheader);
            //alert(acuan);
            //alert(data);
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        onChangeHalaman(event) {
            this.pindahhalaman(event.target.value);
        },
        async pindahhalaman(halamannya) {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            this.halamanawal = halamannya;
            if (this.piuawal != '' && this.selectedid_user != this.piuawal && this.selectedid_user == '') {
                this.selectedid_user = this.piuawal;
            }
            else {
                this.selectedid_user = this.selectedid_user;
            }

            if (this.kegiatanawal != '' && this.selectedjenispekerjaan2 != this.kegiatanawal && this.selectedjenispekerjaan2 == '') {
                this.selectedjenispekerjaan2 = this.kegiatanawal;
            }
            else {
                this.selectedjenispekerjaan2 = this.selectedjenispekerjaan2;
            }

            if (this.tahunawal != '' && this.selectedtahunmulai2 != this.tahunawal && this.selectedtahunmulai2 == '') {
                this.selectedtahunmulai2 = this.tahunawal;
            }
            else {
                this.selectedtahunmulai2 = this.selectedtahunmulai2;
            }

            if (this.lokasiawal != '' && this.selectedlokasi != this.lokasiawal && this.selectedlokasi == '') {
                this.selectedlokasi = this.lokasiawal;
            }
            else {
                this.selectedlokasi = this.selectedlokasi;
            }

            if (this.komponenawal != '' && this.selectedkomponen != this.komponenawal && this.selectedkomponen == '') {
                this.selectedkomponen = this.komponenawal;
            }
            else {
                this.selectedkomponen = this.selectedkomponen;
            }

            if (this.subkomponenawal != '' && this.selectedsubkomponen != this.subkomponenawal && this.selectedsubkomponen == '') {
                this.selectedsubkomponen = this.subkomponenawal;
            }
            else {
                this.selectedsubkomponen = this.selectedsubkomponen;
            }

            if (this.carikataawal != '' && this.carikata != this.carikataawal && this.carikata == '') {
                this.carikata = this.carikataawal;
            }
            else {
                this.carikata = this.carikata;
            }

            this.secretencData = halamannya + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikataawal;
            await mainAPI.get("parastapainnovationmonev-GetMonev?random=" + random + "&project_id="
                + this.project_id + "&halaman=" + halamannya + "&nama=" + this.carikata
                + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser
                + "&lokasi=" + this.selectedlokasi + "&jenispekerjaan=" + this.selectedjenispekerjaan2
                + "&tahun=" + this.selectedtahunmulai2 + "&komponen="
                + this.selectedkomponen + "&subkomponen=" + this.selectedsubkomponen + "&idpiu=" + this.selectedid_user
                + "&lokasi=" + this.selectedlokasi).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        this.colspan = 0;
                        this.datatahun = [];
                        this.colspan = Response.data.jumlahtahun;
                        this.datatahun = Response.data.tahun;
                        //alert(this.datapesan);
                        if (this.datapesan == 'data diketemukan') {
                            this.datamaster = [];
                            this.datamaster = Response.data.content.data;
                            this.jumlahdata = Response.data.content.jumlahdata;
                            this.jumlahhalaman = Response.data.content.jumlahhalaman;
                            this.mulai = Response.data.content.mulai;
                            if (this.mulai == 0) {
                                this.halaman = 1;
                            }
                            else {
                                this.halaman = (this.mulai / 20) + 1;
                            }
                        }
                        else {
                            this.datamaster = [];
                            this.jumlahdata = 0;
                            this.jumlahhalaman = 0;
                            this.mulai = 0;
                        }
                        this.halamanloading = false;
                    }
                ).catch(error => {
                    //console.log(error);
                    //this.ClearlocalStorage();
                    this.halamanloading = false;
                });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.halamanawal);
            //(this.halaman);


            if (this.piuawal != '' && this.selectedid_user != this.piuawal && this.selectedid_user == '') {
                this.selectedid_user = this.piuawal;
                this.halaman = 1;
            }
            else {
                this.selectedid_user = this.selectedid_user;
                this.halaman = 1;
            }

            if (this.kegiatanawal != '' && this.selectedjenispekerjaan2 != this.kegiatanawal && this.selectedjenispekerjaan2 == '') {
                this.selectedjenispekerjaan2 = this.kegiatanawal;
                this.halaman = 1;
            }
            else {
                this.selectedjenispekerjaan2 = this.selectedjenispekerjaan2;
                this.halaman = 1;
            }

            if (this.tahunawal != '' && this.selectedtahunmulai2 != this.tahunawal && this.selectedtahunmulai2 == '') {
                this.selectedtahunmulai2 = this.tahunawal;
                this.halaman = 1;
            }
            else {
                this.selectedtahunmulai2 = this.selectedtahunmulai2;
                this.halaman = 1;
            }

            if (this.lokasiawal != '' && this.selectedlokasi != this.lokasiawal && this.selectedlokasi == '') {
                this.selectedlokasi = this.lokasiawal;
                this.halaman = 1;
            }
            else {
                this.selectedlokasi = this.selectedlokasi;
                this.halaman = 1;
            }

            if (this.komponenawal != '' && this.selectedkomponen != this.komponenawal && this.selectedkomponen == '') {
                this.selectedkomponen = this.komponenawal;
                this.halaman = 1;
            }
            else {
                this.selectedkomponen = this.selectedkomponen;
                this.halaman = 1;
            }

            if (this.subkomponenawal != '' && this.selectedsubkomponen != this.subkomponenawal && this.selectedsubkomponen == '') {
                this.selectedsubkomponen = this.subkomponenawal;
                this.halaman = 1;
            }
            else {
                this.selectedsubkomponen = this.selectedsubkomponen;
                this.halaman = 1;
            }

            if (this.carikataawal != '' && this.carikata != this.carikataawal && this.carikata == '') {
                this.carikata = this.carikataawal;
                this.halaman = 1;
            }
            else {
                this.carikata = this.carikata;
                this.halaman = 1;
            }

            if (this.halamanawal != this.halaman) {
                this.halaman = this.halamanawal;
            }

            this.secretencData = this.halaman + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikataawal;

            await mainAPI.get("parastapainnovationenv-GetEnv?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata
                + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser + "&idpiu=" + this.selectedid_user
                + "&lokasi=" + this.selectedlokasi + "&jenispekerjaan=" + this.selectedjenispekerjaan2 + "&tahun=" + this.selectedtahunmulai2 + "&komponen="
                + this.selectedkomponen + "&subkomponen=" + this.selectedsubkomponen + "&jenispekerjaan=0" + "&halaman=" + this.halaman
                + "&lokasi=" + this.selectedlokasi).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        this.colspan = 0;
                        this.datatahun = [];
                        this.colspan = Response.data.jumlahtahun;
                        this.datatahun = Response.data.tahun;
                        //alert(this.datapesan);
                        if (this.datapesan == 'data diketemukan') {
                            this.datamaster = [];
                            this.datamaster = Response.data.content.data;
                            this.jumlahdata = Response.data.content.jumlahdata;
                            this.jumlahhalaman = Response.data.content.jumlahhalaman;
                            this.mulai = Response.data.content.mulai;
                            if (this.mulai == 0) {
                                this.halaman = 1;
                            }
                            else {
                                this.halaman = (this.mulai / 20) + 1;
                            }
                            this.halamanloading = false;
                        }
                        else {
                            this.datamaster = [];
                            this.jumlahdata = 0;
                            this.jumlahhalaman = 0;
                            this.mulai = 0;
                            this.halamanloading = false;
                        }

                    }
                ).catch(error => {
                    //console.log(error);
                    //this.ClearlocalStorage();
                    this.halamanloading = false;
                });
        },
    },
    mounted() {
        var tmp = this.secretencData.split("_");
        this.halamanawal = tmp[1];
        this.piuawal = tmp[2];
        this.kegiatanawal = tmp[3];
        this.tahunawal = tmp[4];
        this.lokasiawal = tmp[5];
        this.komponenawal = tmp[6];
        this.subkomponenawal = tmp[7];
        this.carikataawal = tmp[8];
        if (tmp[8] != '') {
            this.carikata = tmp[8];
        }

        this.getOtentifikasi();
        this.ambildatareff();
        this.ambildata();
    }
}
</script>
<style></style>